import { getApiBaseUrl } from '../utils'
export default () => {
  const apiBaseUrl = getApiBaseUrl();

  // Original for future reference
  // return async (url, ...args) => {
  //     return await fetch(`${apiBaseUrl}/${url}`, ...args)
  // }

  return async (url, options = {}, ...args) => {
    // The purpose of this is to ensure credentials are always set to the value "include"
    const optionsOverride = {
      ...options,
      credentials: "include"
    }
    return await fetch(`${apiBaseUrl}/${url}`, optionsOverride, ...args)
  }
}